import axios from "axios";
import Cookies from "universal-cookie";
import { get_Token } from "util/Helper";
import { BASE_URL } from "./constants";
import { toast } from "react-toastify";

const cookies = new Cookies();

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});
console.log("token1>>>", get_Token());
console.log("token2>>>", localStorage.getItem("t_id"));

 
axiosInstance.interceptors.request.use(function (config) {
  config.headers["Authorization"] = "Bearer " + get_Token();
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
   async (error) => {
    console.log("error response>>>", error);
    if(error?.response?.data?.code===500 || error?.response?.data?.code===401){
     toast.error(error.response.data.msg, {
       position: "top-right",
     });
    } else if(error.response.data.msg === "must be authenticated first"){
      cookies.remove("t_id", { path: "/" })
      window.location = "/login";
      toast.error(error.response.data.msg, {
        position: "top-right",
      });
      window.location = "/login";
    } else if(error?.response?.data?.code ===403 && error?.response?.data?.msg.toLowerCase().includes("jwt")){
      console.log("403 error>>>");
      console.log("403 JWT/Token error detected >>> redirecting to login...");

      // ✅ Remove everything related to auth
      cookies.remove("t_id", { path: "/" })
      window.localStorage.removeItem("t_id");
      window.localStorage.removeItem("temp_token");
      window.localStorage.removeItem("email_id");

      toast.error("Session expired. Please log in again.", {
        position: "top-right",
      });

      window.location = "/login";
      return; // stop execution here
    } else
    return Promise.reject(error);
    // if (error.response?.status === 403) {
    //   cookies.remove("t_id");
    //   window.location = "/login";
    // } else return Promise.reject(error);
  }
);

export default axiosInstance;
